import { makeAutoObservable, runInAction } from "mobx";
import API from "../../../config";
import axios from "axios";

import { commonAxios } from "../CommonAxios"
class MultiSelectTextBox {
  rootStore;
  fieldKey; // key of the field in the form
  selectedValues = [];
  options = [];
  inputValue = "";
  loading = false;
  totalMatched = -1;
  customOptions = [];
  constructor(rootStore, fieldKey) {
    this.rootStore = rootStore; // Assign rootStore
    this.fieldKey = fieldKey; // Assign rootStore
    makeAutoObservable(this);
    this.addOption = this.addOption.bind(this);
    this.pushNewOption = this.pushNewOption.bind(this);
    this.restoreCustomOptions = this.restoreCustomOptions.bind(this);
    this.setSelectedValues = this.setSelectedValues.bind(this);
    this.restoreSelectedValues = this.restoreSelectedValues.bind(this);
    this.handleClearAll = this.handleClearAll.bind(this);
  }
  async fetchOptions(inputValue = "") {
    if (this.loading) return;
    try {
      runInAction(() => {
        this.loading = true;
      });
      const response = await commonAxios(
        "/searchFillter",
        "POST",
        {},
        {
          fillterKey: this.fieldKey,
          nextCursorMark: "",
          searchKeyword: inputValue ?? "",
        }
      );
      runInAction(() => {
        this.setInputValue(inputValue);
        let existingOptions = this.options || [];
        const newOptions = response?.data?.items ?? [];
        // Use a Map to filter out duplicate values
        const uniqueOptions = [
          ...new Map(
            [...existingOptions, ...newOptions].map((item) => [
              item.value,
              item,
            ])
          ).values(),
        ];
        this.options = uniqueOptions;
        if (this.totalMatched === -1) {
          this.totalMatched = response?.data?.TotalMatching ?? 0;
        }
      });
    } catch (error) {
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }
  removeCustomOptions() {
    runInAction(() => {
      this.options = this.options.filter(option => !option.CustomOption);
    });
  }
  setOptions(options) {
    runInAction(() => {
      this.options = options;
    });
  }
  clearMe() {
    runInAction(() => {
      this.selectedValues = [];
      this.inputValue = "";
      this.totalMatched = -1;
      this.customOptions = [];
      this.removeCustomOptions();
    });
  }
  restoreCustomOptions(value) {
    runInAction(() => {
      this.customOptions = value;
    });
  }
  // setSelectedValues({ values, trigger = false }) {
  //   
  //   this.selectedValues = values;
  //   if (trigger === true) {
  //     this.rootStore.generateCompanyApi({ triggerKey: trigger })
  //   }
  // }
  setSelectedValues({ values = [], trigger = false }) {
    if (!Array.isArray(values)) {
      values = [];
    }
    this.selectedValues = values;
    if (trigger) {
      this.rootStore.generateCompanyApi({ triggerKey: trigger });
    }
  }
  addOption(label) {
    const newOption = { label, value: label.toLowerCase().replace(/\W/g, "") };
    this.options.push(newOption);
    this.selectedValues.push(newOption);
  }
  restoreSelectedValues(selectedValues) {
    return new Promise((resolve) => {
      runInAction(() => {
        this.selectedValues = [];
      });
      setTimeout(() => {
        const valuesToRestore = selectedValues || [];
        const batchSize = 500;
        let currentIndex = 0;
        const processBatch = () => {
          const batch = valuesToRestore.slice(
            currentIndex,
            currentIndex + batchSize
          );
          runInAction(() => {
            this.selectedValues = [...this.selectedValues, ...batch];
          });
          currentIndex += batchSize;
          if (currentIndex < valuesToRestore.length) {
            setTimeout(processBatch, 500);
          } else {
            resolve();
          }
        };
        processBatch();
      }, 2000);
    });
    // runInAction(() => {
    //   this.selectedValues = selectedValues || [];
    // });
  }
  handleClearAll() {
    runInAction(() => {
      this.selectedValues = [];
    });
  }
  setInputValue(inputValue) {
    runInAction(() => {
      this.inputValue = inputValue;
    });
  }
  pushNewOption(inputValue) {
    const valueExists = this.options.some((opt) => opt.value === inputValue);
    if (valueExists) return;
    const newOption = {
      value: inputValue,
      label: inputValue,
      CustomOption: true,
    };
    runInAction(() => {
      this.options = [newOption, ...this.options];
      this.selectedValues = [...this.selectedValues, newOption];
    });
    this.updateCustomOptions();
  }
  updateCustomOptions() {
    const customSelected = this.options.filter(
      (option) =>
        option.CustomOption &&
        this.selectedValues.some((sel) => sel.value === option.value)
    );
    runInAction(() => {
      this.customOptions = customSelected;
    });
  }

  removeSelectedValue(valueToRemove) {
    runInAction(() => {
      this.selectedValues = this.selectedValues.filter(
        (item) => item.value !== valueToRemove.value
      );
      this.customOptions = this.customOptions.filter(
        (item) => item.value !== valueToRemove.value
      );
      // Optional: remove the custom value from options too
      this.options = this.options.filter(
        (item) => item.value !== valueToRemove.value
      );
    });
  }

}
export default MultiSelectTextBox;
